import {
  connectionService,
  RACE_TIMEOUT,
  THING_FIND_URI
} from '@leapsight/styleguide'
import store from '@/store'

export default {
  async getEntities({ connection = null } = {}) {
    let page = 1
    let limit = 1
    try {
      const resThings = await this.thingFind(page, limit, connection)
      const thingPromises = []
      const entities = []
      let delta = resThings?.kwargs?.total
      limit = 200

      while (delta > 0) {
        thingPromises.push(this.thingFind(page, limit, connection))
        page++
        limit += 200
        delta -= limit
      }

      const resThingPromises = await Promise.allSettled(thingPromises)

      resThingPromises.forEach(({ status, value }) => {
        if (status === 'fulfilled') {
          entities.push(...value.args[0])
        } else {
          console.error(value)
        }
      })

      return entities
    } catch (error) {
      console.error(error)
    }
  },
  thingFind(page, limit, connectionParam) {
    // connectionParam is used in cases where this function is called outside of the established connection's scope
    // (i.e: from the ToolbarAppBox component in the Fleet Management module)
    const p1 = new Promise(reject => {
      setTimeout(reject, RACE_TIMEOUT, false)
    })

    const p2 = new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
        ? store.getters['auth/connection']
        : connectionParam

      const args = [connectionService.getAccountId()]
      const kwArgs = connectionService.createkwArgs()
      const options = {}
      kwArgs.types = ['mrn:thing:vehicle', 'mrn:thing:flex']
      kwArgs.query_spec = {
        _p: 'config.services.mrn:service:arflota.status',
        _page: page,
        _limit: limit
      }
      connection?.session.call(THING_FIND_URI, args, kwArgs, options).then(
        response => {
          resolve(response)
        },
        wampError => {
          reject(wampError)
        }
      )
    })

    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  }
}
